import { useSettings } from '@/presentation/context/settings';
import Settings from './Settings';
import { useCallback } from 'react';

const SettingsContainer = () => {
  const [{ slippage }, updateSettings] = useSettings();

  const handleSlippageChange = useCallback(
    (amount: string) => {
      updateSettings({
        slippage: amount,
      });
    },
    [updateSettings]
  );

  return (
    <Settings onSlippageChange={handleSlippageChange} slippage={slippage} />
  );
};

export default SettingsContainer;
